import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const RefreshNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M13.65 2.35C12.2 0.9 10.21 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C11.2567 16 14.0408 14.0561 15.2872 11.2665C15.5647 10.6455 15.0671 10 14.3869 10L-nan -nanL14.3869 10C13.9454 10 13.5598 10.2831 13.363 10.6783C12.382 12.6474 10.349 14 8 14C6.4087 14 4.88258 13.3679 3.75736 12.2426C2.63214 11.1174 2 9.5913 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.66 2 11.14 2.69 12.22 3.78L10.3657 5.63431C9.86171 6.13829 10.2186 7 10.9314 7H15C15.5523 7 16 6.55228 16 6V1.93137C16 1.21865 15.1383 0.861713 14.6343 1.36569L13.65 2.35Z'
            fill='currentColor'
        />
    </svg>
));
